import Cookies from 'js-cookie';
import { getCookieDomain } from './cookieDomain';

export interface PartnerCookieData {
  isPartner: boolean;
}

export function removePartnerCookie(name: string) {
  Cookies.remove(name, { domain: getCookieDomain() });
}

export const PARTNER_COOKIE_NAME = 'fi_partner';
export const PARTNER_COOKIE_EXPIRATION_HOURS = 72;
